import React from 'react';
import './style.scss';

/**
 * LayoutCanvas component - used for non-authenticated pages.
 *
 * @param {Object} props - Props for the LayoutCanvas component.
 * @param {React.ReactNode} props.children - The children elements.
 * @returns {JSX.Element} The LayoutCanvas component.
 * @example
 *  <LayoutCanvas>
        ...
    </LayoutCanvas>
 */
function LayoutCanvas({ children }) {
    return (
        <div className="canvas-layout">
            <div className="app-content">
                {children}
            </div>
        </div>
    );
}

export default LayoutCanvas;
